import { render } from "./HomeStartSection.vue?vue&type=template&id=11fb385c&scoped=true"
import script from "./HomeStartSection.vue?vue&type=script&lang=js"
export * from "./HomeStartSection.vue?vue&type=script&lang=js"

import "./HomeStartSection.vue?vue&type=style&index=0&id=11fb385c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fb385c"]])

export default __exports__